"use client"

import { Heart } from "lucide-react"
import { useWishlist } from "@lib/context/wishlist-context"

export default function WishlistButton({
  productId,
  productTitle,
  className = "absolute top-2 right-2 w-8 h-8 rounded-full bg-white shadow-sm border border-gray-100 flex items-center justify-center transition-colors z-10",
}: {
  productId: string
  productTitle?: string
  className?: string
}) {
  const { toggle, isInWishlist } = useWishlist()
  const active = isInWishlist(productId)

  return (
    <button
      type="button"
      className={className}
      aria-label={active ? `Remove ${productTitle || "product"} from wishlist` : `Add ${productTitle || "product"} to wishlist`}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        toggle(productId)
      }}
    >
      <Heart
        className={`w-4 h-4 transition-colors ${
          active ? "text-red-500 fill-red-500" : "text-gray-400 hover:text-red-500"
        }`}
      />
    </button>
  )
}
